/**
 * ACS (Accounts.AI) Project Data for Intellesphere Organization
 * Complete project with all tasks and new P1 phase for automated anomaly analysis
 */

import type { Organization, Project, Epic, Task, User } from '../types';

export const intellesphereOrg: Organization = {
  id: 'org_intellesphere',
  projects: ["project-acs", "project-mavenpromo"],
  name: 'Intellesphere',
  users: [
    { userId: 'user-anindya', role: 'admin' },
    { userId: 'user-rafi', role: 'developer' },
    { userId: 'user-emtiaj', role: 'developer' },
    { userId: 'user-avro', role: 'developer' },
    { userId: 'user-adil', role: 'developer' },
    { userId: 'user-abhik', role: 'developer' },
    { userId: 'user-abrar', role: 'developer' },
    { userId: 'user-sayem', role: 'developer' },
    { userId: 'user-jakaria', role: 'developer' },
    { userId: 'user-sameen', role: 'developer' },
    { userId: 'user-masud', role: 'business_analyst' },
    { userId: 'intellesphere', role: 'developer' },
    { userId: 'ah.masud.phd', role: 'developer' },
    { userId: 'pemsapi', role: 'developer' },
    { userId: 'aidimentry', role: 'developer' },
    { userId: 'user-ashraf', role: 'qa' },
    { userId: 'asif.redmond@gmail.com', role: 'developer' },
  ],
  createdAt: '2024-01-01T00:00:00.000Z',
};

export const intellesphereUsers: User[] = [
  {
    id: 'user-anindya',
    name: 'Anindya Iqbal',
    email: 'anindya@intellesphere.ai',
    role: 'admin',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-rafi',
    name: 'Rafi',
    email: 'rafi@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-emtiaj',
    name: 'Emtiaj',
    email: 'emtiaj@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-avro',
    name: 'Avro',
    email: 'pemsapi@gmail.com',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-adil',
    name: 'Adil',
    email: 'adil@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-abhik',
    name: 'Abhik',
    email: 'ah.masud.phd@gmail.com',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-abrar',
    name: 'Abrar',
    email: 'abrar@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-sayem',
    name: 'Sayem',
    email: 'ah.masud.phd@gmail.com',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-jakaria',
    name: 'Jakaria',
    email: 'jakaria@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-sameen',
    name: 'Sameen',
    email: 'ah.masud.phd@gmail.com',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-masud',
    name: 'Masud',
    email: 'intellesphere@gmail.com',
    role: 'business_analyst',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'user-ashraf',
    name: 'Ashraf',
    email: 'pemsapi@gmail.com',
    role: 'qa',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
  {
    id: 'asif.redmond@gmail.com',
    name: 'Sabit',
    email: 'sabit@intellesphere.ai',
    role: 'developer',
    organizations: ['org_intellesphere'],
    changeStats: { totalChanges: 0, lastChangeDate: '' },
  },
];

export const acsProject: Project = {
  id: 'project-acs',
  organizationId: 'org_intellesphere',
  name: 'ACS (Accounts.AI)',
  description: 'AI-powered accounting and compliance system with GL analysis, chatbots, and project management capabilities',
  status: 'In Progress',
  proposal: 'Develop Accounts.AI - A comprehensive AI-powered accounting system with GL analysis, law chatbots, project QA, and customizable plugins for various accounting workflows.',
  costs: [
    {
      id: 'cost-1',
      description: 'Development and Implementation',
      amount: 5000000,
      category: 'Development',
    },
  ],
  teamMembers: [
    { userId: 'user-anindya', role: 'admin' },
    { userId: 'user-rafi', role: 'developer' },
    { userId: 'user-emtiaj', role: 'developer' },
    { userId: 'user-avro', role: 'developer' },
    { userId: 'user-adil', role: 'developer' },
    { userId: 'user-abhik', role: 'developer' },
    { userId: 'user-abrar', role: 'developer' },
    { userId: 'user-sayem', role: 'developer' },
    { userId: 'user-jakaria', role: 'developer' },
    { userId: 'user-sameen', role: 'developer' },
    { userId: 'user-masud', role: 'business_analyst' },
    { userId: 'user-ashraf', role: 'qa' },
    { userId: 'asif.redmond@gmail.com', role: 'developer' },
  ],
  createdAt: '2024-06-01T00:00:00.000Z',
  updatedAt: '2024-08-01T00:00:00.000Z',
  approvedAt: '2024-06-05T00:00:00.000Z',
  startDate: '2024-06-16T00:00:00.000Z',
  targetEndDate: '2024-08-03T00:00:00.000Z',
  externalLinks: [],
};

export const acsEpics: Epic[] = [
  {
    id: 'epic-poc-test',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'PoC Test Issues',
    description: 'Testing and validation of proof of concept implementations',
    status: 'Completed',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-05T00:00:00.000Z',
  },
  {
    id: 'epic-intellesphere-ai',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Intellesphere.AI Business',
    description: 'Business operations including incubator proposals, NDA, and website',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-aqc',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'AQC (Accounts Quality Control)',
    description: 'Core accounting features including GL analysis, export history, and integrations',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-chatbot',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Chatbot',
    description: 'AI chatbot features including chat history, multiple messages, settings, and persistence',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-law-chatbot',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Law Chatbot',
    description: 'Legal document analysis and law retrieval chatbot with Bangla support',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-devops',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'DevOps/CICD',
    description: 'DevOps, CI/CD, deployment, and infrastructure management',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-project-mgmt',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Project Management',
    description: 'Project management features including cloning, archiving, export/import, and multi-table support',
    status: 'In Progress',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-08-03T00:00:00.000Z',
  },
  {
    id: 'epic-frontend-plugin',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Frontend Plugins',
    description: 'Customizable frontend plugins for various workflows including Gantt charts, reports, and industry-specific features',
    status: 'Not Started',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-06-01T00:00:00.000Z',
  },
  {
    id: 'epic-dashboard',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Dashboard',
    description: 'Project and organization dashboards with analytics',
    status: 'Completed',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
  },
  {
    id: 'epic-security',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Security',
    description: 'Role-based access control and security vulnerabilities',
    status: 'Not Started',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-06-01T00:00:00.000Z',
  },
  {
    id: 'epic-p1-anomaly',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Automated Anomaly Analysis',
    description: 'New phase for automated anomaly detection and analysis using LLM to generate responses for pre-generated question sets',
    status: 'Not Started',
    taskIds: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
  },
];

// Helper function to map assignee names to user IDs
const getAssigneeId = (assigneeName: string): string => {
  const mapping: Record<string, string> = {
    'Rafi': 'user-rafi',
    'Anindya': 'user-anindya',
    'Adil': 'user-adil',
    'Avro': 'user-avro',
    'Emtiaj': 'user-emtiaj',
    'Abhik': 'user-abhik',
    'Abrar': 'user-abrar',
    'Sayem': 'user-sayem',
    'Jakaria': 'user-jakaria',
    'Sameen': 'user-sameen',
    'Masud': 'user-masud',
    'Ashraf': 'user-ashraf',
    'Sabit': 'asif.redmond@gmail.com',
    'Emtiaz': 'user-emtiaj',
  };
  
  // Handle multiple assignees
  const assignees = assigneeName.split(/[,&]/).map(a => a.trim());
  const ids = assignees.map(a => {
    const key = Object.keys(mapping).find(k => a.includes(k));
    return key ? mapping[key] : '';
  }).filter(Boolean);
  
  return ids[0] || 'user-rafi'; // Default to Rafi if not found
};

// Helper function to map status
const mapStatus = (status: string): any => {
  const statusMap: Record<string, any> = {
    'DONE': 'Completed',
    'Not Started': 'Not Started',
    'In Progress': 'In Progress',
    'In Beta': 'In Progress',
    'Stuck': 'Blocked',
  };
  return statusMap[status] || 'Not Started';
};

// Helper function to map priority
const mapPriority = (priority: string): any => {
  const priorityMap: Record<string, any> = {
    'CRITICAL': 'Critical',
    'HIGH': 'High',
    'Medium': 'Medium',
    'LOW': 'Low',
  };
  return priorityMap[priority] || 'Medium';
};

export const acsTasks: Task[] = [
  // PoC Test Issues
  {
    id: 'task-bug1-law',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Law retrieval GUI requires clicking files for the first time',
    description: 'Bug fix for law retrieval GUI interface',
    type: 'Bug',
    status: 'Completed',
    priority: 'Critical',
    category: 'PoC',
    assigneeIds: ['user-rafi'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-poc-test',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-03T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-avl2',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Deploy second ACS server',
    description: 'Set up and deploy second ACS server for redundancy',
    type: 'Task',
    status: 'Completed',
    priority: 'Critical',
    category: 'Testing',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-poc-test',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-02T00:00:00.000Z',
    targetEndDate: '2024-07-02T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-tqa1',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'QA results issues [q take long time]',
    description: 'Performance issues with QA queries taking too long',
    type: 'Bug',
    status: 'Completed',
    priority: 'Critical',
    category: 'Testing',
    assigneeIds: ['user-abrar'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-poc-test',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-03T00:00:00.000Z',
    updatedAt: '2024-07-05T00:00:00.000Z',
    targetEndDate: '2024-07-05T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-tlr1',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Law Retrieval Results/Issues',
    description: 'Address issues with law retrieval system results',
    type: 'Bug',
    status: 'Completed',
    priority: 'Critical',
    category: 'Testing',
    assigneeIds: ['user-sayem'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-poc-test',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-03T00:00:00.000Z',
    targetEndDate: '2024-07-03T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-tin1',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Infrastructure test issues',
    description: 'Resolve infrastructure-related testing issues',
    type: 'Bug',
    status: 'Completed',
    priority: 'High',
    category: 'Testing',
    assigneeIds: ['user-rafi'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-poc-test',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-02T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  
  // Business/Intellesphere.AI
  {
    id: 'task-bip1',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Incubator proposal',
    description: 'Create and submit incubator proposal for Intellesphere.AI',
    type: 'Task',
    status: 'Completed',
    priority: 'Critical',
    category: 'Business',
    assigneeIds: ['user-anindya'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-intellesphere-ai',
    estimatedDays: 5,
    estimatedHours: 40,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-06-10T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-bnd2',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'NDA Signed By All',
    description: 'Ensure all team members sign the NDA',
    type: 'Task',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Business',
    assigneeIds: ['user-anindya'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-intellesphere-ai',
    estimatedDays: 0.5,
    estimatedHours: 4,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-24T00:00:00.000Z',
    updatedAt: '2024-07-24T00:00:00.000Z',
    startDate: '2024-07-24T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-bi0',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Intellesphere website',
    description: 'Design and develop Intellesphere company website',
    type: 'Task',
    status: 'Not Started',
    priority: 'High',
    category: 'Business',
    assigneeIds: ['user-avro', 'user-rafi'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-intellesphere-ai',
    estimatedDays: 2.5,
    estimatedHours: 20,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  
  // AQC Epic
  {
    id: 'task-aqc0-design',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'GL Design [Proposal][Tasks][IntegrationSchema]',
    description: 'Design general ledger proposal, tasks breakdown, and integration schema',
    type: 'Research',
    status: 'Completed',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-abhik'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-06-16T00:00:00.000Z',
    updatedAt: '2024-06-20T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-gl-backend',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'GL backend changes',
    description: 'Implement backend changes for General Ledger analysis',
    type: 'Task',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Backend',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 4,
    estimatedHours: 32,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-23T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    startDate: '2024-07-23T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-gl-frontend',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'GL Frontend changes',
    description: 'Implement frontend changes for General Ledger analysis UI',
    type: 'Task',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Frontend',
    assigneeIds: ['user-avro', 'user-rafi'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-23T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    startDate: '2024-07-23T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-parse-ledger1',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Parse Ledger30062024 Sep09.xlsx',
    description: 'Parse and process Ledger30062024 Sep09.xlsx file',
    type: 'Research',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-23T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    startDate: '2024-07-23T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-parse-ledger2',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Parse Ledger.xlsx',
    description: 'Parse and process Ledger.xlsx file',
    type: 'Research',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-24T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    startDate: '2024-07-24T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-parse-broiler',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Parse Broiler cobb 5000.xls',
    description: 'Parse and process Broiler cobb 5000.xls file',
    type: 'Research',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-24T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    startDate: '2024-07-24T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-integrate-qa-gl',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Integrate QA with GL',
    description: 'Integrate question-answering system with General Ledger',
    type: 'Research',
    status: 'In Progress',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-abrar'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-20T00:00:00.000Z',
    updatedAt: '2024-07-25T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-gl-qa-testing',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'GL QA Testing',
    description: 'Quality assurance testing for General Ledger functionality',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Testing',
    assigneeIds: ['user-abrar'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-20T00:00:00.000Z',
    updatedAt: '2024-07-20T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-export-history-changes',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Export history changes',
    description: 'Implement export functionality for history changes',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Backend',
    assigneeIds: ['user-rafi'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-export-history',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Export history',
    description: 'Implement export history feature',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Backend',
    assigneeIds: ['user-adil'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-aqc',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-01T00:00:00.000Z',
    updatedAt: '2024-07-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  
  // Dashboard
  {
    id: 'task-dashboard-frontend',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Project/org dashboard frontend',
    description: 'Build frontend for project and organization dashboards',
    type: 'Task',
    status: 'Completed',
    priority: 'High',
    category: 'Frontend',
    assigneeIds: ['user-avro'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-dashboard',
    estimatedDays: 1.5,
    estimatedHours: 12,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-10T00:00:00.000Z',
    updatedAt: '2024-07-20T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-dashboard-backend',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'Project/org dashboard backend',
    description: 'Build backend for project and organization dashboards',
    type: 'Task',
    status: 'In Progress',
    priority: 'High',
    category: 'Backend',
    assigneeIds: ['user-emtiaj', 'user-avro'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-dashboard',
    estimatedDays: 0.125,
    estimatedHours: 1,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-07-10T00:00:00.000Z',
    updatedAt: '2024-07-20T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  
  // P1: Automated Anomaly Analysis Tasks
  {
    id: 'task-p1-design',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Design Anomaly Detection Architecture',
    description: 'Design the architecture for automated anomaly detection system including data flow, LLM integration, and question set framework',
    type: 'Research',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-abhik', 'user-emtiaj'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 5,
    estimatedHours: 40,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-question-set',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Create Pre-generated Question Sets',
    description: 'Define and create comprehensive question sets for common accounting anomalies including duplicate entries, mismatched balances, unusual transactions, compliance violations',
    type: 'Research',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Research',
    assigneeIds: ['user-masud', 'user-anindya'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 4,
    estimatedHours: 32,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-anomaly-detection',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Implement Anomaly Detection Engine',
    description: 'Build core anomaly detection engine that analyzes GL data and identifies potential issues using statistical methods and pattern recognition',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Backend',
    assigneeIds: ['user-emtiaj', 'user-abrar'],
    parentTaskIds: ['task-p1-design'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 10,
    estimatedHours: 80,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-design',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-llm-integration',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: LLM Integration for Response Generation',
    description: 'Integrate LLM to generate natural language responses for detected anomalies based on pre-generated question sets',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'ML Infra',
    assigneeIds: ['user-sayem', 'user-abhik'],
    parentTaskIds: ['task-p1-design', 'task-p1-question-set'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 8,
    estimatedHours: 64,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-design,task-p1-question-set',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-response-pipeline',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Build Automated Response Pipeline',
    description: 'Create pipeline that automatically runs question sets against detected anomalies and generates LLM responses',
    type: 'Task',
    status: 'Not Started',
    priority: 'High',
    category: 'Backend',
    assigneeIds: ['user-adil'],
    parentTaskIds: ['task-p1-anomaly-detection', 'task-p1-llm-integration'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 6,
    estimatedHours: 48,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-anomaly-detection,task-p1-llm-integration',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-ui-dashboard',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Anomaly Dashboard UI',
    description: 'Create dashboard UI to display detected anomalies, analysis results, and LLM-generated responses with filtering and drill-down capabilities',
    type: 'Task',
    status: 'Not Started',
    priority: 'High',
    category: 'Frontend',
    assigneeIds: ['user-avro', 'user-rafi'],
    parentTaskIds: ['task-p1-design'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 7,
    estimatedHours: 56,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-design',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-alert-system',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Anomaly Alert & Notification System',
    description: 'Implement real-time alert system to notify users when critical anomalies are detected via email, SMS, and in-app notifications',
    type: 'Task',
    status: 'Not Started',
    priority: 'High',
    category: 'Backend',
    assigneeIds: ['user-adil'],
    parentTaskIds: ['task-p1-anomaly-detection'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 4,
    estimatedHours: 32,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-anomaly-detection',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-reporting',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Anomaly Analysis Reports',
    description: 'Generate comprehensive anomaly analysis reports with visualizations, trends, and LLM insights for management review',
    type: 'Task',
    status: 'Not Started',
    priority: 'Medium',
    category: 'Frontend',
    assigneeIds: ['user-avro'],
    parentTaskIds: ['task-p1-response-pipeline'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 5,
    estimatedHours: 40,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-response-pipeline',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-ml-model-training',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Train ML Models for Pattern Recognition',
    description: 'Train machine learning models on historical data to improve anomaly detection accuracy and reduce false positives',
    type: 'Research',
    status: 'Not Started',
    priority: 'High',
    category: 'ML Infra',
    assigneeIds: ['user-abrar', 'user-sayem'],
    parentTaskIds: ['task-p1-anomaly-detection'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 10,
    estimatedHours: 80,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-anomaly-detection',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-question-customization',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Question Set Customization Interface',
    description: 'Build UI allowing users to customize and add their own question sets for domain-specific anomaly analysis',
    type: 'Task',
    status: 'Not Started',
    priority: 'Medium',
    category: 'Frontend',
    assigneeIds: ['user-rafi'],
    parentTaskIds: ['task-p1-question-set'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 4,
    estimatedHours: 32,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-question-set',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-testing-qa',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: QA Testing & Validation',
    description: 'Comprehensive testing of anomaly detection system including accuracy validation, performance testing, and edge case handling',
    type: 'Task',
    status: 'Not Started',
    priority: 'Critical',
    category: 'Testing',
    assigneeIds: ['user-ashraf', 'user-abrar'],
    parentTaskIds: ['task-p1-response-pipeline', 'task-p1-ui-dashboard'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 6,
    estimatedHours: 48,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-response-pipeline,task-p1-ui-dashboard',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-performance-optimization',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Performance Optimization',
    description: 'Optimize system performance for handling large datasets, reduce LLM response time, and implement caching strategies',
    type: 'Task',
    status: 'Not Started',
    priority: 'High',
    category: 'Backend',
    assigneeIds: ['user-emtiaj'],
    parentTaskIds: ['task-p1-testing-qa'],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 4,
    estimatedHours: 32,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    dependencies: 'task-p1-testing-qa',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
  {
    id: 'task-p1-documentation',
    organizationId: 'org_intellesphere',
    projectId: 'project-acs',
    title: 'P1: Documentation & User Guide',
    description: 'Create comprehensive documentation including technical docs, user guides, and best practices for anomaly analysis',
    type: 'Task',
    status: 'Not Started',
    priority: 'Medium',
    category: 'Business',
    assigneeIds: ['user-masud', 'user-anindya'],
    parentTaskIds: [],
    subtaskIds: [],
    epicId: 'epic-p1-anomaly',
    estimatedDays: 3,
    estimatedHours: 24,
    timeLogs: [],
    standupNotes: [],
    createdAt: '2024-08-01T00:00:00.000Z',
    updatedAt: '2024-08-01T00:00:00.000Z',
    customerVisible: false,
    attachments: [],
    verificationLinks: [],
    externalLinks: [],
    changeLogs: [],
  },
];
